




























import Vue from "vue";
import iwInputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({

    components: {
        iwInputNumber: iwInputNumber,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            pathInStore: "property.livingDescription.netHabitableSurface",
            specificId: uuidv4() as string,
            inputName: "floor-area"
        };
    },
    computed: {
        floorArea: function(): string|null {
            const fArea = this.$store.getters["FormModule/getValue"](this.pathInStore);
            if(fArea) {
                return this.$store.getters["FormModule/getValue"](this.pathInStore);
            }
            return "";
        },
        isOptional: function(): boolean {
            const mandatoryPropertyTypes = ["OFFICE", "INDUSTRY", "COMMERCIAL", "HOMES_TO_BUILD"];

            return mandatoryPropertyTypes.indexOf(this.getPropertyType()) === -1;
        },
        isDisplayed: function(): boolean {
            return ["HOUSE","OFFICE","INDUSTRY","COMMERCIAL","APARTMENT","OTHER","HOMES_TO_BUILD"].indexOf(this.getPropertyType()) !== - 1;
        },
    },
    methods: {
        updateValue: function(floorArea: number): void {
            if (floorArea == 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": floorArea});
            }
        }
    }
});

